export const createMessageShort = /* GraphQL */ `
  mutation createMessageShort(
    $input: CreateMessageInput!
    $condition: ModelmessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      content
      createdAt
      expiration_time
      chat_id
      image_url
      user_id {
        id
        name
        last_name
        role
      }
    }
  }
`;

export const updateAccountInterest = /* GraphQL */ `
  mutation UpdateAccount($id: ID!, $interests: [String]) {
    updateAccount(input: { id: $id, interests: $interests }) {
      id
      interests
    }
  }
`;

export const updateNikuCoins = /* GraphQL */ `
  mutation UpdateNikucoins($id: ID!, $nikucoins: Float) {
    updateAccount(input: { id: $id, nikucoins: $nikucoins }) {
      nikucoins
      name
      id
      email
    }
  }
`;

export const updateRating = /* GraphQL */ `
  mutation updateRating($id: ID!, $rating: Float) {
    updateShop(input: { id: $id, rating: $rating }) {
      id
      rating
    }
  }
`;

export const createReview = /* GraphQL */ `
  mutation CreateReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      id
      note
      comment
      createdAt
    }
  }
`;

export const createCategoryUser = /* GraphQL */ `
  mutation CreateCategoryUser(
    $input: CreateCategoryUserInput!
    $condition: ModelcategoryUserConditionInput
  ) {
    createCategoryUser(input: $input, condition: $condition) {
      id
      category_id {
        category_name
      }
      user_id {
        name
        last_name
      }
    }
  }
`;

export const createNewChat = /* GraphQL */ `
  mutation createNewChat(
    $input: CreateChatInput!
    $condition: ModelchatConditionInput
  ) {
    createChat(input: $input, condition: $condition) {
      id
    }
  }
`;

export const joinUserChat = /* GraphQL */ `
  mutation joinUserChat(
    $input: CreateChatUserInput!
    $condition: ModelchatUserConditionInput
  ) {
    createChatUser(input: $input, condition: $condition) {
      id
      user_id {
        name
        last_name
      }
    }
  }
`;

export const setCurrentSession = /* GraphQL */ `
  mutation setCurrentSession(
    $input: UpdateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      current_session
    }
  }
`;

export const associateCustomerToOrder = /* GraphQL */ `
  mutation AssociateCustomerToOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
      customer_id {
        id
      }
      discount
      percentage
      final_total
      payment_id
      status
      level
      discount_array {
        id
      }
    }
  }
`;

export const updateOrder = /* GraphQL */ `
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      shop_idToSort
      id
      customer_id {
        id
      }
      discount
      final_total
      payment_id
      status
      level
      phase
      shop_id {
        id
        deleted_at
      }
      delivery_man_id {
        id
        role
        name
        last_name
        notification_token
        url_photoProfile
      }
    }
  }
`;

export const updateDeliveryStatus = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      delivery_inprocess
      name
      notification_token
    }
  }
`;

export const updateValueOrders = /* GraphQL */ `
  mutation updateValueOrders($input: UpdateShopInput!) {
    updateShop(input: $input) {
      id
      deleted_at
    }
  }
`;

export const updateOrderCaseDB = /* GraphQL */ `
  mutation updateOrderCaseDB($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
      order_case
    }
  }
`;

export const updateHistoryReminders = /* GraphQL */ `
  mutation updateHistoryReminders($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
      reminders
    }
  }
`;

export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      role
      availability
      delivery_inprocess
    }
  }
`;
export const updateAccountOpenpay = /* GraphQL */ `
  mutation UpdateAccount($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      openPay_id
    }
  }
`;

export const updateCognitoUserInfo = /* GraphQL */ `
  mutation UpdateAccount($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      id
      phone_number
      birthday
      zip_codes
    }
  }
`;

export const updateBirthday = /* GraphQL */ `
  mutation updateBirthday($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      id
      birthday
    }
  }
`;

export const updateDiscountStatus = /* GraphQL */ `
  mutation UpdateDiscount(
    $input: UpdateDiscountInput!
    $condition: ModeldiscountConditionInput
  ) {
    updateDiscount(input: $input, condition: $condition) {
      id
      for_use
    }
  }
`;

export const updatePercentage = /* GraphQL */ `
  mutation UpdatePercentage(
    $input: UpdatePercentageInput!
    $condition: ModelpercentageConditionInput
  ) {
    updatePercentage(input: $input, condition: $condition) {
      id
      value
      array_ofDiscount
    }
  }
`;

export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelorderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
    }
  }
`;

export const mutationDeleteUserAddress = /* GraphQL */ `
  mutation mutationDeleteUserAddress($id: ID!) {
    deleteUserAddress(input: { id: $id }) {
      id
    }
  }
`;

export const mutationDeleteAddress = /* GraphQL */ `
  mutation mutationDeleteAddress($id: ID!) {
    deleteAddress(input: { id: $id }) {
      id
    }
  }
`;

export const createOrderProduct = /* GraphQL */ `
  mutation CreateOrderProduct(
    $input: CreateOrderProductInput!
    $condition: ModelorderProductConditionInput
  ) {
    createOrderProduct(input: $input, condition: $condition) {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
          role
          nikucoins
          deleted_at
          name
          last_name
          availability
          email
          current_session
          delivery_inprocess
          createdAt
          updatedAt
        }
        status
        level
        discount
        final_total
        products {
          nextToken
        }
        method_pay
        payment_id
        address
        order_type
        shop_id {
          id
          shop_name
          business_name
          category
          description
          availability
          status
          schedule
          phone_number
          url_image
          price
          deleted_at
          address_shop
          shop_type
          createdAt
          updatedAt
        }
        require_bill
        require_service
        shop_comments
        discount_array {
          id
          value
          for_use
          used
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      product_id {
        id
        shop_id {
          id
          shop_name
          business_name
          category
          description
          availability
          status
          schedule
          phone_number
          url_image
          price
          deleted_at
          address_shop
          shop_type
          createdAt
          updatedAt
        }
        product_name
        description
        url_image
        tags
        price
        status
        product_type
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelorderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      customer_id {
        id
      }
      status
      level
      discount
      final_total
      method_pay
      address
      order_type
      require_service
      createdAt
      updatedAt
      order_case
      total
    }
  }
`;

export const updateChat = /* GraphQL */ `
  mutation UpdateChat(
    $input: UpdateChatInput!
    $condition: ModelchatConditionInput
  ) {
    updateChat(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateUpdateDiscountArraybyShopId = /* GraphQL */ `
  mutation UpdateShop(
    $input: UpdateShopInput!
    $condition: ModelshopConditionInput
  ) {
    updateShop(input: $input, condition: $condition) {
      id
      discountsArray
    }
  }
`;

export const updatePendingChats = /* GraphQL */ `
  mutation updatePendingChats(
    $input: UpdateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      pending_chats
    }
  }
`;

// & -------------------------- ACTIALIZAR PRODUCTOS -------------------------- */

export const updateProd = /* GraphQL */ `
  mutation updateProd($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
    }
  }
`;

//create favorite (favorite - shop)
export const createFav = /* GraphQL */ `
  mutation createFav($userId: ID, $shopId: ID) {
    createFavorite(
      input: { favoriteUser_idId: $userId, favoriteShop_idId: $shopId }
    ) {
      id
    }
  }
`;

//drop favortite
export const deleteFav = /* GraphQL */ `
  mutation deleteFav($id: ID!) {
    deleteFavorite(input: { id: $id }) {
      id
    }
  }
`;

//update profile photo
export const updateAccountPhotoProfile = /* GraphQL */ `
  mutation updateAccountPhotoProfile($id: ID!, $url_photoProfile: String) {
    updateAccount(input: { id: $id, url_photoProfile: $url_photoProfile }) {
      id
      url_photoProfile
    }
  }
`;

export const updateUserAddress = /* GraphQL */ `
  mutation UpdateUserAddress(
    $input: UpdateUserAddressInput!
    $condition: ModeluserAddressConditionInput
  ) {
    updateUserAddress(input: $input, condition: $condition) {
      id
      active
    }
  }
`;

export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress(
    $input: UpdateAddressInput!
    $condition: ModeladdressConditionInput
  ) {
    updateAddress(input: $input, condition: $condition) {
      id
      country
      city
      street
      outdoor_number
      interior_number
      town
      postal_code
      latitude
      longitude
      zip_codes
      user_addresses {
        items {
          id
          active
          tag
          zip_codes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
